import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function factorial(n) {
    switch (n) {
        case 1:  return  1;
        case 2:  return  3;
        case 3:  return  6;
        case 4:  return 10;
        case 5:  return 15;
        case 6:  return 21;
        case 7:  return 28;
        case 8:  return 36;
        case 9:  return 45;
        case 10: return 55;
        case 11: return 66;
        case 12: return 78;
        default: return  0;
    }
}

export default new Vuex.Store({
    state: {
        marks: {
            'red': [],
            'yellow': [],
            'green': [],
            'blue': []
        },
        penalties: []
    },
    mutations: {
        toggle(state, payload) {
            let i = state.marks[payload.color].indexOf(payload.number)
            if (i === -1) {
                state.marks[payload.color].push(payload.number);
            } else {
                state.marks[payload.color].splice(i, 1);
            }
        },
        togglePenalty(state, payload) {
            let i = state.penalties.indexOf(payload)
            if (i === -1) {
                state.penalties.push(payload);
            } else {
                state.penalties.splice(i, 1);
            }
        }
    },
    actions: {
    },
    modules: {
    },
    getters: {
        penalties: (state) => state.penalties.length,
        hasPenalty: (state) => (i) => {
            return state.penalties.indexOf(i) !== -1;
        },
        score: (state) => (color) => {
            let ret = 0;

            if (color === undefined) {
                ret += factorial(state.marks["red"].length);
                ret += factorial(state.marks["yellow"].length);
                ret += factorial(state.marks["green"].length);
                ret += factorial(state.marks["blue"].length);
            } else {
                ret += factorial(state.marks[color].length);
            }

            return ret;
        }
    }
})
